// extracted by mini-css-extract-plugin
var _1 = "PageTitle-module__animateUploadProgressBarWidth--X8LKu";
var _2 = "PageTitle-module__animatedBackground--guyYK";
var _3 = "PageTitle-module__subtitle--O919r";
var _4 = "PageTitle-module__title--Sh4ux";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "subtitle", _4 as "title" }
